<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char30">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>
            <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
            <IpServicoSelect :ckAddTodos="true" v-model:ipservicoSelecionado="idServico" />
            
            <button type="button" class="buttom-icon--map" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>
    

    <div v-if="lsDados" class="form-edit-page">
        <div>
            <MapArrayLegendComponent class="map" :coordinates="lsDados"></MapArrayLegendComponent>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import IpServicoSelect from '@/selects/IpServicoSelect.vue';
import MapArrayLegendComponent from '@/components/MapArrayLegendComponent.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const idServico = ref(0);
const isLoading = ref(false);
const lsDados = ref(null);
const msgAlerta = ref(null);

const lsOpcoes = ref([
    {id: 'ipos_executados', descricao: 'Serviços Executados'},
    {id: 'ipos_aguardando', descricao: 'Serviços Aguardando'},
    {id: 'solicitacoes_aguardando', descricao: 'Solicitações Aguardando'},
    {id: 'todos_aguardando', descricao: 'Todos Aguardando'},
]);
const opcaoSelecionada = ref('todos_aguardando');

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        const req = await genericPost('/ip/coordenadas', {
            idmunicipio: globalStore.idmunicipio,
            idservico: idServico.value,
            strparam1: opcaoSelecionada.value,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate});
        lsDados.value = req;
    } finally {isLoading.value = false;}
}
</script>